import { lazyIsTeamsMeetNowEnabled } from 'owa-teams-policies-lazy';
import type { TeamsPoliciesScenario } from 'owa-teams-policies-lazy/lib/store/schema';

export async function isTeamsMeetNowEnabled(scenario?: TeamsPoliciesScenario): Promise<boolean> {
    return lazyIsTeamsMeetNowEnabled.importAndExecute(scenario);
}
